// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

<template>
  <a-card class="row-paddding card">
    <a-row :gutter="12">
      <a-col :xl="4">
        {{ $t('label.ansible.url') }}
      </a-col>
      <a-col :xl="8">
        <a-input v-model:value="url" :disabled="isDisabled != 0" />
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :xl="4">
        {{ $t('label.ansible.organization') }}
      </a-col>
      <a-col :xl="8">
        <a-input v-model:value="organization" :disabled="isDisabled != 0" />
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :xl="4">
        {{ $t('label.ansible.project') }}
      </a-col>
      <a-col :xl="8">
        <a-input v-model:value="project" :disabled="isDisabled != 0" />
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :xl="4">
        {{ $t('label.ansible.username') }}
      </a-col>
      <a-col :xl="8">
        <a-input v-model:value="username" :disabled="isDisabled != 0" />
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :xl="4">
        {{ $t('label.ansible.password') }}
      </a-col>
      <a-col :xl="8">
        <a-input type="password" v-model:value="password" :disabled="isDisabled != 0" />
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :xl="4">
        {{ $t('label.ansible.prefix') }}
      </a-col>
      <a-col :xl="8">
        <a-input v-model:value="prefix" :disabled="isDisabled != 0" />
      </a-col>
    </a-row>
    <a-row :gutter="12">
      <a-col :xl="4">
        {{ $t('label.ansible.allowed.source.cidrs') }}
      </a-col>
      <a-col :xl="8">
        <a-input v-model:value="allowedSourceCidrs" :disabled="isDisabled != 0" />
        <div class="form-help">{{ $t('message.ansible.allowed.source.cidrs') }}</div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { getAPI } from '@/api'

export default {
  name: 'AnsibleParams',
  components: {},
  props: {
    isReadOnly: Boolean
  },
  data () {
    return {
      url: '',
      organization: '',
      project: '',
      username: '',
      password: '',
      prefix: '',
      allowedSourceCidrs: '10.0.0.0/8,172.16.0.0/12,192.168.0.0/16'
    }
  },
  mounted () {
    this.fetchData()
  },
  provide: function () {
    return {}
  },
  computed: {
    isDisabled: function () {
      return this.isReadOnly
    }
  },
  methods: {
    async fetchData () {
      this.loading = true
      try {
        const parameters = await this.getParameters()
        for (var i in parameters.listconfigurationsresponse.configuration) {
          var param = parameters.listconfigurationsresponse.configuration[i]
          if (param.name === 'ansible.awx.organization') {
            this.organization = param.value
          } else if (param.name === 'ansible.awx.project') {
            this.project = param.value
          } else if (param.name === 'ansible.awx.url') {
            this.url = param.value
          } else if (param.name === 'ansible.awx.prefix') {
            this.prefix = param.value
          } else if (param.name === 'ansible.awx.username') {
            this.username = param.value
          } else if (param.name === 'ansible.awx.allowed_source_cidrs') {
            this.allowedSourceCidrs = param.value
          }
        }
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    getParameters () {
      return new Promise((resolve, reject) => {
        const params = {}
        params.name = 'ansible'

        getAPI('listConfigurations', params)
          .then((json) => {
            resolve(json)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}
</script>

<style scoped>
.row-paddding div {
  margin-top: 4px;
  margin-bottom: 4px;
}
.form-help {
  color: rgba(0, 0, 0, 0.55);
  font-size: 12px;
  margin-top: 4px;
}
</style>
